import type { AxiosResponse } from 'axios';

import type { DuplicatedOrderStatus } from '~/types/Order';
import { microServiceAPI } from '~/services/api';
import { WEB_ORDERS_API } from '~/services/web-orders.service';

/**
 * Clones an order with the specified order ID.
 *
 * @param {string} orderId - The ID of the order to be cloned.
 *
 * @return {Promise<AxiosResponse<string>>} - A promise that resolves to the response received from the server for the clone order request.
 */
export function cloneOrder(orderId: string): Promise<AxiosResponse<DuplicatedOrderStatus>> {
  return microServiceAPI.request({
    url: `${WEB_ORDERS_API}/${orderId}/clone`,
    method: 'POST',
  });
}
